import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTask: builder.query({
      query: (id) =>
        `/tasks/${id}`,
      keepUnusedDataFor: 0,
      // providesTags: (result, error, arg) => [{ type: "Task", id: arg }],
    }),
    addTask: builder.mutation({
      query: ({ payload }) => ({
        url: "/tasks",
        method: "POST",
        body: payload,
      }),
      async onQueryStarted({ arg }, { queryFulfilled, dispatch }) {
        try {
          const task = await queryFulfilled;
          if (task?.data?.id) {
            // update tasks cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData(
                "getTasks",
                undefined,
                (draft) => {
                  draft.push(task.data)
                }
              )
            );
            // update tasks cache pessimistically end
          }
        } catch (err) { }
      },
    }),
    updateTask: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: payload,
      }),
      // invalidatesTags: (result, error, arg) => [{ type: "Task", id: arg.id }],
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const task = await queryFulfilled;
          if (task?.data?.id) {
            const { taskName, teamMember, project, deadline, status, id } = task?.data || {};
            // update tasks cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData(
                "getTasks",
                undefined,
                (draft) => {
                  const draftTask = draft.find(
                    (t) => t.id == id
                  );
                  draftTask.taskName = taskName;
                  draftTask.teamMember = teamMember;
                  draftTask.project = project;
                  draftTask.deadline = deadline;
                  draftTask.status = status;
                }
              )
            );
            // update tasks cache pessimistically end
          }
        } catch (err) { }
      },
    }),
    deleteTask: builder.mutation({
      query: ({ id }) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const result = dispatch(
          apiSlice.util.updateQueryData(
            "getTasks",
            undefined,
            (draft) => {
              return draft.filter((task) => task.id != arg.id);
            }
          )
        );
        // optimistic cache update end
        try {
          await queryFulfilled;
        } catch (err) {
          result.undo();
        }
      },
    }),
  }),
});

export const { useGetTasksQuery, useGetTaskQuery, useAddTaskMutation, useUpdateTaskMutation, useDeleteTaskMutation } = tasksApi;
